import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import { Fragment } from "react";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import ConnorsAgeGate from "../../components/paid_landing_page/ConnorsAgeGate/ConnorsAgeGate";
import PaidLandingPageContent from "../../components/paid_landing_page/PaidLandingPage/PaidLandingPageContent";
import { PAID_LANDING_PAGE_BANNER_FRAGMENT } from "../../components/paid_landing_page/paidLandingPageStrapiFragment";
import SharedFooter from "../../components/shared/SharedFooter/SharedFooter";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import MTPUploadResumeFloating from "../../components/shared/UploadResumeFloating/wrappers/MTPUploadResumeFloating";
import * as config from "../../config/config";
import { getPaidPartnershipPageAttributes } from "../../redux/actions/company_action";

function ConnersCollective({ ssrPaidLandingPageBanner }) {
  let metaTitle = "Connor's Collective Jobs, Careers & Hiring in Malaysia";
  let metaDescription =
    "Discover the latest Connor's Collective career opportunities in Malaysia, explore featured roles, and apply for jobs that match your skills and interests on Hiredly.";

  return (
    <Fragment>
      <Head>
        {/* <!-- Primary Meta Tags --> */}
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" key={"ogType"} />
        <meta
          property="og:url"
          content="https://my.hiredly.com/paid-landing-page"
          key="ogUrl"
        />
        <meta property="og:title" content={metaTitle} key="ogTitle" />
        <meta
          property="og:description"
          content={metaDescription}
          key="ogDescription"
        />
        <meta
          property="og:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="ogImage"
        />

        {/* <!-- Twitter --> */}
        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitterCard"
        />
        <meta
          property="twitter:url"
          content="https://my.hiredly.com/paid-landing-page"
          key="twitterUrl"
        />
        <meta property="twitter:title" content={metaTitle} key="twitterTitle" />
        <meta
          property="twitter:description"
          content={metaDescription}
          key="twitterDescription"
        />
        <meta
          property="twitter:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="twitterImage"
        />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link rel="canonical" href="https://my.hiredly.com/paid-landing-page" />
      </Head>
      <ToResolveClassNameError>
        <SharedNavbar2
          page="user-landing-page"
          breadcrumbItems={[{ label: "nav.paid_landing_page_hub" }]}
        />
        <Toolbar />
      </ToResolveClassNameError>
      <ConnorsAgeGate>
        <PaidLandingPageContent initialBanner={ssrPaidLandingPageBanner} />
        <ToResolveClassNameError>
          <SharedFooter />
        </ToResolveClassNameError>
        <MTPUploadResumeFloating />
      </ConnorsAgeGate>
    </Fragment>
  );
}

export async function getServerSideProps() {
  try {
    const attributes = await getPaidPartnershipPageAttributes(
      PAID_LANDING_PAGE_BANNER_FRAGMENT
    );

    return {
      props: {
        ssrPaidLandingPageBanner: attributes?.banner ?? null,
      },
    };
  } catch (error) {
    console.error("getServerSideProps connors-collective banner:", error);
    return {
      props: {
        ssrPaidLandingPageBanner: null,
      },
    };
  }
}

export default ConnersCollective;
